import Axios, { AxiosInstance, AxiosResponse } from 'axios';

import { GLOBAL_SERVICE } from '@configs';

import { APIClientRequestParameters } from './api-client.types';

export class APIClient {
  private static readonly api: AxiosInstance = Axios.create({
    baseURL: GLOBAL_SERVICE,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
  });

  static readonly post = <TResponse, TPayload>(
    params: APIClientRequestParameters<TPayload>
  ): Promise<AxiosResponse<TResponse>> => {
    return this.api({
      method: 'post',
      url: params.url,
      data: params.payload,
      baseURL: params.baseURL,
      timeout: params.timeout,
    });
  };

  static readonly get = <TResponse, TPayload = void>(
    params: APIClientRequestParameters<TPayload>
  ): Promise<AxiosResponse<TResponse>> => {
    return this.api({
      method: 'get',
      url: params.url,
      params: { ...params.payload },
      baseURL: params.baseURL,
      timeout: params.timeout,
    });
  };

  static readonly setLanguage = (language: string) => {
    this.api.defaults.headers.common['Accept-Language'] = language;
  };
}
